<template>
    <div>
        <button
            v-if="task.status == 'ok'"
            class="btn btn-white-border btn-icon icon-small toggle-task"
            @click.stop="completed(task.id)"
        >
            <i></i>
        </button>
        <button
            v-else
            class="btn btn-primary btn-icon icon-small toggle-task"
            @click.stop="uncompleted(task.id)"
        >
            <i class="icon-validate fs-2"></i>
        </button>
        <div>
            <p v-if="task.label" class="fs-2 gray-60">
                <span class="chip" :style="{ backgroundColor: '#' + task.labelColor }"></span
                >{{ task.label }}
            </p>
            <p v-if="task.title" class="mt-1 mb-0 bold">{{ task.title }}</p>
            <p :class="task.title ? 'mt-0 mb-1' : 'my-1'" v-html="task.description"></p>
            <p class="fs-2 gray-60">
                <span>{{ $filters.dateFormatter(task.timestampStart, 'SLASHED_DATE_TIME') }}</span>
                <span v-if="task.relatedname" class="ml-3">
                    <a
                        class="link fs-2 regular gray-60"
                        :href="task.relatedlink"
                        @click="stopPropagation"
                    >
                        <span>{{ task.relatedname }}</span>
                    </a>
                </span>
                <span v-if="task.parentname" class="ml-3">
                    <a
                        class="link fs-2 regular gray-60"
                        :href="task.parentlink"
                        @click="stopPropagation"
                    >
                        <span>{{ task.parentname }}</span>
                    </a>
                </span>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        task: {
            type: Object,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
    },
    methods: {
        uncompleted(id) {
            let target = 'current';
            if (this.task.timestampStart < moment().unix()) {
                target = 'late';
            } else if (this.task.timestampStart > moment().endOf('day').unix()) {
                target = 'incoming';
            }
            EventBus.emit('toggle_task', {
                id: id,
                source: 'completed',
                target: target,
                status: 'ok',
            });
            axios.post('/?_f=agendaEvent', { action: 'uncomplete', id: id });
        },
        completed(id) {
            EventBus.emit('toggle_task', {
                id: id,
                source: this.type,
                target: 'completed',
                status: 'completed',
            });
            axios.post('/?_f=agendaEvent', { action: 'complete', id: id });
        },
        stopPropagation(event) {
            event.stopPropagation();
        },
    },
};
</script>
